import jsPDF from "jspdf";
import brand_logo from "../../../assets/brand_logo4.png";

const loadImageAsBase64 = async (url) => {
    try {
        if (!url) return null;

        const res = await fetch(url);
        if (!res.ok) return null;

        const blob = await res.blob();

        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error("Image load failed:", url, error);
        return null;
    }
};

const getImageType = (base64 = "") => {
    if (base64.includes("image/jpeg") || base64.includes("image/jpg")) return "JPEG";
    if (base64.includes("image/webp")) return "WEBP";
    return "PNG";
};

const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

const generateBillServices = async ({
    bookIds = [],
    rooms = [],
    form,

    services = [],
    serviceTotal = 0,

    nights = 0,
    grandTotal = 0,
    paidAmount = 0,
    receivedAdvance = 0,
    remainingPayable = 0,
    discountAmount = 0,

    paymentStatus = "",
    loyaltyDiscountPercent = 0,
    loyaltyDiscountAmount = 0,

    gst = 0,
    gstPercent = 0,
    gstAmount = 0,
    gstType = "inclusive",

    headerImg = "",
    footerImg = "",

    totalHours = 0,
    bookingType = "Day",
    ratePerHour = 0,

    overdue_amount = 0,
    overdue_duration = "",
    early_checkin_amount = 0,

    isHistory = false,
    showUnitName = true,
}) => {
    console.log("gstType", gstType);
    console.log("services?", services);

    const W = 80;
    const margin = 5;
    const contentW = W - margin * 2;

    const fmtRs = (v, decimals = 0) =>
        `Rs.${num(v).toLocaleString("en-IN", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        })}`;

    const cleanStatus = (v = "") => String(v || "").trim().toLowerCase();

    const serviceList = Array.isArray(services)
        ? services.filter((s) => s && cleanStatus(s.status) !== "cancelled")
        : [];

    const getServiceName = (item) =>
        item?.service_type === "custom"
            ? item?.service_name || "-"
            : item?.inhouse_service_name || item?.service_name || "-";

    const getServiceStatus = (item) => {
        const status =
            item?.payment_status ||
            item?.paymentStatus ||
            item?.service_payment_status ||
            item?.is_paid ||
            item?.paid_status ||
            item?.status ||
            "";

        if (
            status === "paid" ||
            status === true ||
            status === 1 ||
            status === "1"
        ) {
            return "paid";
        }

        const finalStatus = cleanStatus(status);

        if (["paid", "completed", "success", "fully paid"].includes(finalStatus)) {
            return "paid";
        }

        return "unpaid";
    };

    const servicePaymentStatus =
        serviceList.length === 0
            ? "NO SERVICE REQUEST"
            : serviceList.every((item) => getServiceStatus(item) === "paid")
                ? "PAID"
                : "UNPAID";

    const getServiceAmount = (item) => {
        const qty = num(item.quantity) || 1;
        const rate = num(item.price) || num(item.rate);
        return num(item.total_amount) || qty * rate;
    };

    const finalServiceTotal =
        num(serviceTotal) ||
        serviceList.reduce((sum, item) => sum + getServiceAmount(item), 0);

    const unpaidServiceTotal = serviceList.reduce((sum, item) => {
        return getServiceStatus(item) === "paid"
            ? sum
            : sum + getServiceAmount(item);
    }, 0);

    const finalGstPercent = num(gstPercent || gst);
    const finalGstAmount = num(gstAmount);

    const discount = num(discountAmount);
    const paid = num(paidAmount);
    const advance = num(receivedAdvance);

    const form_payment_summary = form?.pricing_summary
        ? JSON.parse(form.pricing_summary)
        : {};

    console.log("form_payment_summary++++", form_payment_summary);

    let roomChargesTotal = 0;

    const roomRows = Array.isArray(rooms)
        ? rooms.map((roomItem, index) => {
            const roomName = roomItem?.room_name || roomItem?.room_type || "Room";
            const roomNo = roomItem?.room_number ? ` - ${roomItem.room_number}` : "";

            const roomRate =
                num(roomItem?.rate_per_night) ||
                num(roomItem?.price_per_day) ||
                num(roomItem?.room_price);

            const qty =
                num(nights) > 0
                    ? num(nights)
                    : num(totalHours) > 0
                        ? num(totalHours)
                        : 1;

            const amount =
                num(roomItem?.total_amount) ||
                num(roomItem?.base_total) ||
                num(roomItem?.room_total) ||
                roomRate * qty;

            roomChargesTotal += amount;

            return {
                index,
                name: `${roomName}${roomNo}`,
                rate: roomRate,
                qty,
                amount,
            };
        })
        : [];

    roomChargesTotal += num(early_checkin_amount);
    roomChargesTotal += num(overdue_amount);

    const totalBillAmount =
        num(grandTotal) ||
        roomChargesTotal + finalServiceTotal + finalGstAmount - discount;

    const subTotal = roomChargesTotal + finalServiceTotal;
    const grandTotalAfterDiscount = Math.max(totalBillAmount, 0) - discount;

    // ✅ Corrected balance calculation
    // If service is PAID, remove service amount from balance calculation.
    // If service is UNPAID, only unpaid service amount is considered.
    const payableAmount =
        grandTotalAfterDiscount - finalServiceTotal + unpaidServiceTotal;

    const balanceDue = Math.max(payableAmount - paid, 0);

    const finalStatus =
        paymentStatus || (balanceDue <= 0 ? "FULLY PAID" : "PAYMENT PENDING");

    let autoHeight = 172;
    autoHeight += roomRows.length * 9;
    if (serviceList.length > 0) autoHeight += serviceList.length * 9 + 18;
    if (footerImg) autoHeight += 18;

    const doc = new jsPDF({
        unit: "mm",
        format: [W, Math.max(autoHeight, 190)],
        compress: true,
    });

    let y = 4;

    const centerText = (text, yPos) => {
        doc.text(String(text), W / 2, yPos, { align: "center" });
    };

    const line = () => {
        doc.setDrawColor(180);
        doc.setLineWidth(0.2);
        doc.line(margin, y, W - margin, y);
        y += 3;
    };

    const dashedLine = () => {
        doc.setDrawColor(180);
        doc.setLineDashPattern([1, 1], 0);
        doc.line(margin, y, W - margin, y);
        doc.setLineDashPattern([], 0);
        y += 3.5;
    };

    const sectionTitle = (title) => {
        y += 1.5;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(7.4);
        doc.text(title, margin, y);
        y += 2.5;
        line();
    };

    const row = (label, value, bold = false) => {
        doc.setFont("helvetica", bold ? "bold" : "normal");
        doc.setFontSize(7);

        doc.text(String(label), margin, y);
        doc.text(String(value ?? "-"), W - margin, y, { align: "right" });

        y += 4.6;
    };

    const rowWrap = (label, value) => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(6.8);

        doc.text(String(label), margin, y);

        const lines = doc.splitTextToSize(String(value || "-"), contentW - 25);

        lines.forEach((lineText, index) => {
            doc.text(lineText, margin + 25, y + index * 3.6);
        });

        y += Math.max(4.8, lines.length * 3.6 + 1);
    };

    const tableHeader = (columns) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(6.2);

        columns.forEach((col) => {
            doc.text(col.label, col.x, y, {
                align: col.align || "left",
            });
        });

        y += 3;
        line();
    };

    const headerBase64 = await loadImageAsBase64(headerImg);

    if (headerBase64) {
        doc.addImage(headerBase64, getImageType(headerBase64), 0, y, W, 22);
        y += 22;
    } else {
        try {
            doc.addImage(brand_logo, "PNG", 14, y, 52, 18);
            y += 19;
        } catch {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            centerText("HOTEL BILL", y + 8);
            y += 14;
        }
    }

    if (showUnitName) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(7);
        doc.setTextColor(80);
        centerText("Unit of Sri Chakra Enterprises", y + 3);
    }
    y += 7;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.3);
    centerText(`Bill No: ${bookIds?.[0] || form?.br_id || form?.id || "-"}`, y);
    y += 4;

    dashedLine();

    sectionTitle("GUEST DETAILS");
    rowWrap("Guest Name", form?.guest_name || "-");
    rowWrap("Phone", form?.phone || "-");

    if (form?.email) rowWrap("Email", form.email);
    if (form?.customer_gst) rowWrap("GST No", form.customer_gst);
    if (form?.address) rowWrap("Address", form.address);

    dashedLine();

    sectionTitle("STAY DETAILS");
    row(
        "Check-In",
        `${form?.check_in || "-"}${form?.check_in_time ? ` ${form.check_in_time}` : ""}`
    );
    row(
        "Check-Out",
        `${form?.check_out || "-"}${form?.check_out_time ? ` ${form.check_out_time}` : ""}`
    );

    row("Booking Type", bookingType || "Day");

    if (num(nights) > 0) row("Nights", nights);
    if (num(totalHours) > 0) row("Total Hours", totalHours);
    if (num(ratePerHour) > 0 && num(totalHours) > 0) {
        row("Rate / Hour", fmtRs(ratePerHour));
    }

    row("Adults", form?.guests || "-");
    row("Room Details", form?.room_name || "-");

    dashedLine();

    sectionTitle("ROOM PRICE LIST");

    if (num(early_checkin_amount) > 0) {
        row("Early Check-In", fmtRs(early_checkin_amount));
    }

    if (num(overdue_amount) > 0) {
        row(
            `Overdue${overdue_duration ? ` (${overdue_duration})` : ""}`,
            fmtRs(overdue_amount)
        );
    }

    const storedRoomChargesTotal = num(
        form_payment_summary?.total_before_loyalty_discount
    );
    row(
        "Total Room Charge",
        fmtRs(
            storedRoomChargesTotal > 0
                ? storedRoomChargesTotal + num(overdue_amount)
                : roomChargesTotal
        )
    );

    if (finalGstPercent > 0) {
        if (gstType === "inclusive") {
            const gstAmount = num(form_payment_summary?.gst_amount);
            const half = gstAmount / 2;
            row(`CGST (${finalGstPercent / 2}%)`, fmtRs(half));
            row(`SGST (${finalGstPercent / 2}%)`, fmtRs(half));
        } else {
            row(`GST (${finalGstPercent}% Included)`, "");
        }
    }

    if (serviceList.length > 0) {
        dashedLine();
        sectionTitle("SERVICE REQUEST PRICE LIST");

        tableHeader([
            { label: "Service", x: margin },
            { label: "Qty", x: 39, align: "center" },
            { label: "Rate", x: 50, align: "right" },
            { label: "Amount", x: 64, align: "right" },
            { label: "Status", x: W - margin, align: "right" },
        ]);

        serviceList.forEach((item, index) => {
            const serviceName = getServiceName(item);
            const category = item?.category ? ` (${item.category})` : "";
            const fullName = `${index + 1}. ${serviceName}${category}`;

            const qty = num(item.quantity) || 1;
            const rate = num(item.price) || num(item.rate);
            const amount = getServiceAmount(item);
            const status = getServiceStatus(item).toUpperCase();

            const lines = doc.splitTextToSize(fullName, 31);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(6.1);

            lines.forEach((txt, lineIndex) => {
                doc.text(txt, margin, y + lineIndex * 3.2);
            });

            doc.text(String(qty), 39, y, { align: "center" });
            doc.text(fmtRs(rate), 50, y, { align: "right" });
            doc.text(fmtRs(amount), 64, y, { align: "right" });
            doc.text(status, W - margin, y, { align: "right" });

            y += Math.max(6.8, lines.length * 3.2 + 2);
        });

        line();
        row("Service Charges Total", fmtRs(finalServiceTotal), true);
        row("Service Payment Status", servicePaymentStatus, true);
    }

    dashedLine();

    sectionTitle("GRAND TOTAL SUMMARY");

    if (num(loyaltyDiscountPercent) > 0) {
        row(
            `Loyalty Discount (${loyaltyDiscountPercent}%)`,
            `-${fmtRs(loyaltyDiscountAmount)}`
        );
    }

    if (discount > 0) {
        row("Discount Applied", `-${fmtRs(discount)}`);
    }

    const billGrandTotal = num(grandTotal) > 0
        ? num(grandTotal) - discount
        : grandTotalAfterDiscount;
    row("Grand Total", fmtRs(billGrandTotal), true);

    if (!isHistory) {
        if (advance > 0 && advance !== paid) row("Advance Received", fmtRs(advance));
        if (paid > 0) row("Paid Amount", fmtRs(paid));
    }

    row("Balance Due", fmtRs(balanceDue), true);

    y += 2;

    doc.setFillColor(
        balanceDue <= 0 ? 235 : 255,
        balanceDue <= 0 ? 255 : 245,
        balanceDue <= 0 ? 240 : 230
    );

    doc.roundedRect(margin, y, contentW, 8, 1.5, 1.5, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.2);
    centerText(`Payment Status: ${finalStatus}`, y + 5.2);

    y += 11;

    dashedLine();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.setTextColor(0);
    centerText("Thank you for your stay. Visit again!", y);
    y += 6;

    if (footerImg) {
        const footerBase64 = await loadImageAsBase64(footerImg);

        if (footerBase64) {
            doc.addImage(footerBase64, getImageType(footerBase64), 0, y, W, 14);
            y += 16;
        }
    }

    const finalBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(finalBlob);

    window.open(pdfUrl, "_blank");
};

export default generateBillServices;